const PORTAL_ADMIN_ROLES = ["administrador", "desenvolvedor"];

const PORTAL_ADMIN_COMPANIES = [
  "modelo",
  "capricche",
  "sabara",
  "capetro",
  "divisao",
];

export function isPortalAdminCompany(company: unknown): boolean {
  const normalized = String(company ?? "").trim().toLowerCase();
  return PORTAL_ADMIN_COMPANIES.includes(normalized);
}

export function isPortalAdminUser(acp: unknown, company: unknown): boolean {
  const role = String(acp ?? "").trim().toLowerCase();
  return (
    PORTAL_ADMIN_ROLES.includes(role) && isPortalAdminCompany(company)
  );
}
